const env = {
    // url: 'http://localhost:4000/',
    // api: 'http://localhost:4000/api/v1/candidato/',
    // candidates: 'http://localhost:8080/',
    // baseUrl: 'http://localhost:8080/',

    url: 'https://api-sus.novo.org.br/',
    api: 'https://api-sus.novo.org.br/api/v1/candidato/',
    candidates: 'https://vagas.novo.org.br/',
    baseUrl: 'https://vagas.novo.org.br/',

    // url: 'https://api2-sus.novo.org.br/',
    // api: 'https://api2-sus.novo.org.br/api/v1/candidato/',
    // candidates: 'https://vagas2.novo.org.br/',
    // baseUrl: 'https://vagas2.novo.org.br/',

    title: 'Vagas NOVO',
}

export default env;
